import { useEffect, useState } from 'react'
import { api } from '../api/client'
import { Select } from './ui'

/** POD o PDR già noto del cliente (`GET /api/contracts/forniture-cliente`), con i campi del blocco luce o gas. */
export interface FornituraNota {
  tipo: 'pod' | 'pdr'
  codice: string
  campi: Record<string, string>
  contractId: number
  referenceCode: string
  operatorId: number | null
  data: string | null
}

const indirizzo = (f: FornituraNota) => {
  const s = f.tipo === 'pdr' ? 'PDR' : 'POD'
  return [f.campi[`INDIRIZZO_${s}`], f.campi[`NUM_CIVICO_${s}`], f.campi[`ID_COMUNE_${s}`]].filter(Boolean).join(' ')
}

/**
 * "Forniture già note del cliente": per una nuova pratica sullo stesso cliente (anche con un altro operatore) si sceglie
 * un POD o PDR delle sue pratiche e il blocco luce o gas si compila con codice, indirizzo e dati tecnici.
 */
export function FornitureNoteSelect({ customerId, excludeContractId, operatorName, disabled, onApply }: {
  customerId: number
  excludeContractId?: number
  operatorName?: (id: number | null) => string | undefined
  disabled?: boolean
  onApply: (fields: Record<string, string>) => void
}) {
  const [items, setItems] = useState<FornituraNota[]>([])
  const [scelta, setScelta] = useState('')
  useEffect(() => {
    let alive = true
    const qs = new URLSearchParams({ customerId: String(customerId), ...(excludeContractId ? { excludeContractId: String(excludeContractId) } : {}) })
    api<FornituraNota[]>(`/api/contracts/forniture-cliente?${qs}`)
      .then(r => { if (alive) setItems(r) })
      .catch(() => { if (alive) setItems([]) })
    return () => { alive = false }
  }, [customerId, excludeContractId])

  if (items.length === 0) return null
  return (
    <Select
      id="fornitureNote"
      label="Forniture già note del cliente"
      value={scelta}
      disabled={disabled}
      supportingText="Scegli un POD o PDR delle pratiche del cliente: il blocco luce o gas si compila con i suoi dati."
      onChange={e => {
        const f = items.find(x => `${x.tipo}|${x.codice}` === e.target.value)
        setScelta('')
        if (f) onApply({ ...f.campi, [f.tipo === 'pdr' ? 'FORNITURA_CONTRATTO_GAS' : 'FORNITURA_CONTRATTO_LUCE']: 'SI' })
      }}
    >
      <option value="">— Scegli una fornitura —</option>
      {items.map(f => (
        <option key={`${f.tipo}|${f.codice}`} value={`${f.tipo}|${f.codice}`}>
          {f.tipo === 'pdr' ? 'Gas' : 'Luce'} · {f.codice}{indirizzo(f) ? ` · ${indirizzo(f)}` : ''} · pratica {f.referenceCode}
          {operatorName?.(f.operatorId) ? ` (${operatorName(f.operatorId)})` : ''}
        </option>
      ))}
    </Select>
  )
}
